import { Directive, Input, ElementRef, HostListener, EventEmitter, Output } from '@angular/core';
import { UtilsService } from '@core/services/utils/utils.service';

@Directive({
  selector: '[appFormatInput]'
})
export class FormatInputDirective{
  @Input ('inputText') inputText!: string;
  @Output() ngModelChange = new EventEmitter();
  constructor(
    private readonly elementRef: ElementRef
  ) {
   }
  @HostListener('input', ['$event'])
  onInputChange(event): void {
    let initialValue = this.elementRef.nativeElement.value;
    const replace = initialValue.replace(/[^0-9-.]/g, '');
    let countFormat = Number.parseFloat(replace) < 0 ? Number.parseFloat(replace) * -1 : Number.parseFloat(replace)
    if (Number.isNaN(countFormat)) { countFormat = 0}
    if (Number.isNaN(countFormat) || countFormat == 0) {
      this.elementRef.nativeElement.value = ''
    } else if (countFormat > 999999) {
      this.elementRef.nativeElement.value = '999,999';
    } else {
      this.elementRef.nativeElement.value = UtilsService.formatNumber(countFormat);
    }
  }
  // @HostListener('blur', ['$event'])
  // onInputBlur(event): void {
  //   let initialValue = this.elementRef.nativeElement.value;
  //   if(initialValue == '' || initialValue == 0){
  //     this.elementRef.nativeElement.classList.add('animation') 
  //     this.elementRef.nativeElement.value = 1
  //     setTimeout(() => {
  //       this.elementRef.nativeElement.classList.remove('animation') 
  //     }, 1000)
  //   }
  // }
}